import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { OpcoesAssinatura } from '../opcoes-assinatura.model';
import { AssinaturaService } from '../assinatura-service';

//import { NavController } from 'ionic-angular';
//import { ActionSheetController } from 'ionic-angular';

declare var promiseAssinaturaTCE: any;

@Component({
  selector: 'tce-assinatura-eletronica',
  templateUrl: './assinatura-eletronica-component.html'
})
export class AssinaturaEletronicaComponent implements OnInit{

  assinaturaTO: any;

  @Input() opcoes: OpcoesAssinatura;
  @Input() disabled: boolean = false;
  @Input() showButton: boolean = true;
  @Output() sucesso = new EventEmitter();
  @Output() erro = new EventEmitter();  

  constructor(private assinaturaService: AssinaturaService) {}

  ngOnInit() {
    this.assinaturaTO = this.assinaturaService.getAssinaturaTO();
    this.assinaturaService.iniciarCertificados();
  }

  iniciarAssinatura(opcoesLocal?: OpcoesAssinatura) {
    try {
      // if (this.assinaturaService.isExtensaoInstalada()) {
      //   this.assinaturaService.iniciarAssinatura(opcoesLocal ? opcoesLocal : this.opcoes);
      // } else {
      //   this.assinaturaService.instalarExtensao();
      // }
      this.assinaturaService.iniciarAssinatura(opcoesLocal ? opcoesLocal : this.opcoes);
    } catch (error) {
      console.log(error);
      // TODO:MOSTRAR PARA O USUÁRIO
      // this.msg.mostrarMensagemErro(error);
    }
  }

  assinar() {

    this.assinaturaService.assinarPromise().then(
        () => this.sucesso.emit('Assinatura atualizada com sucesso na base de dados.'),
        () => this.erro.emit('Erro ao processar a assinatura. ')
      );
      
    //this.assinaturaService.assinar();

    // const sucessoLocal = this.sucesso;

    /*TODO: - mostra na para o usuário os erros na asinautra.;*/
  /*   promiseAssinaturaTCE.then(
      () => sucessoLocal.emit('Assinatura atualizada com sucesso na base de dados.'),
      () => console.log('Erro ao atualizar a assinatura na base de dados. ')
    ) */
  }

  reloadListaDeCertificados() {
    this.assinaturaService.iniciarCertificados();
  }

  getJsonAssinatura() {
    return this.assinaturaTO;
  }

}



// WEBPACK FOOTER //
// ./src/assinatura/assinatura-eletronica/assinatura-eletronica-component.ts